/** Mensagem padrão quando não há empresa ativa válida no contexto do usuário. */
export const MSG_NO_ACTIVE_COMPANY =
  "Nenhuma empresa ativa. Antes de prosseguir ative uma empresa. Caso o usuário não possua acesso, contate o administrador do sistema.";

/**
 * Empresa ativa só é válida se estiver entre as permitidas ao usuário (tb_sca_user_company).
 * Evita carregar GSF com id persistido sem permissão («Sem empresas» no header).
 */
export function resolveActiveCompany(user) {
  const id = user?.active_company_id ?? null;
  const companies = Array.isArray(user?.permitted_companies)
    ? user.permitted_companies
    : [];
  if (id == null) {
    return { id: null, record: null, isValid: false };
  }
  const record =
    companies.find((c) => Number(c.id_entity_company) === Number(id)) ?? null;
  return {
    id,
    record,
    isValid: record != null,
  };
}
